<div class="mfunsPlayer-danmaku-list-panel">
    <div class="mfunsPlayer-danmaku-list-wrap">
        <div class="mfunsPlayer-danmaku-list-head">
            <span class="list-column col-time">时间</span><span class="list-column col-text">弹幕内容</span><span class="list-column col-date">发送时间</span>
        </div>
        <div class="mfunsPlayer-danmaku-list-container">
            <div class="mfunsPlayer-danmaku-list"></div>
        </div>
        <div class="mfunsPlayer-danmaku-list-status">
            <div class="status-loading-text">弹幕列表装填中……</div>
            <div class="status-failed-text">弹幕加载失败 X_X</div>
            <div class="status-empty-text">还没有弹幕哦，快来发弹幕^_^</div>
        </div>
    </div>
    <div class="mfunsPlayer-danmaku-auxiliary-foot">
        <div class="flex-left">
            <span class="mfunsPlayer-danmaku-list-autoscroll">
                列表滚动[关]
            </span>
        </div>
        <div class="flex-right">
            <div class="mfunsPlayer-controller-button mfunsPlayer-ade-button" title="高级弹幕">
                <i class="mfunsPlayer-controller-icon icon-advanced-danmaku"></i>
            </div>
        </div>
    </div>
</div>
<div class="mfunsPlayer-ade-panel mode-pos" style="display: none">
    {{include './advancedDanmakuPosEditor.art'}}
    {{include './advancedDanmakuJsonEditor.art'}}
    <div class="mfunsPlayer-danmaku-auxiliary-foot">
        <div class="flex-left">
            <span>切换弹幕模式:</span>
            <span class="mfunsPlayer-ade-mode-selector">
                <span class="label-pos">定位弹幕</span>
                <span class="label-json">JSON弹幕</span>
            </span>
        </div>
        <div class="flex-right">
            <div class="mfunsPlayer-controller-button mfunsPlayer-ade-exit-button" title="返回">
                <i class="mfunsPlayer-controller-icon icon-left-arrow"></i>
            </div>
        </div>
    </div>
</div>